import { SET_TOKEN, SET_USER_INFO } from "./types";

const userAction = (payload) => {
  return {
    type: "userData",
    payload
  }
}
export default userAction;


export const setUserInfo = value => {
  return async dispatch => {
    dispatch({
      type: SET_USER_INFO,
      payload: value,
    });
  };
};

export const setApiToken = value => {
  return async dispatch => {
    dispatch({
      type: SET_TOKEN,
      payload: value,
    });
  };
};
